/*******************************************************************************

  Project: Redact
  Author: XXX
  Date: XX.XXXX

********************************************************************************

  1. Scroll to
  2. Off canvas menu
  3. EU Cookie
  4. Dropdown Menu
  5. Lightbox for images and videos
  6. Responsive Videos
  7. Scoll Animations Init
  8. Object Fit Images
  9. Framework Scripts
  10. Contact Form 7 Fix
  11. Accordion
  12. Map
  13. Equal Heights
  14. Logo list
  15. Smooth Scroll
  16. Video Play
  17. Slick carousel - article
  18. Team Carousel
  19. Photo Carousel
  20. Statistics
  21. Load more blog posts

*******************************************************************************/

jQuery( document ).ready(function($) {

/* 1. Scroll to
------------------------------------------------------------------------------*/

  $(document).on( 'scroll', function(){
    if ($(window).scrollTop() > 200) {
      $('.scroll-to-top').addClass('show');
    } else {
      $('.scroll-to-top').removeClass('show');
    }
  });

  $('.button-to-top').on('click', function(event) {
    event.preventDefault();
    var verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
    var element = $('body');
    var offset = element.offset();
    var offsetTop = offset.top;
    $('html, body').animate({scrollTop: offsetTop}, 500, 'linear');
  });

  $('.scroll-to-top').on('click', function(event) {
    event.preventDefault();
    var verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
    var element = $('body');
    var offset = element.offset();
    var offsetTop = offset.top;
    $('html, body').animate({scrollTop: offsetTop}, 500, 'linear');
  });

  if ((window.location.href.indexOf("projekte-kategorien") > -1) || (window.location.href.indexOf("agentur-kategorien") > -1)){
    var element = $('#filter');
    var offset = element.offset();
    var offsetTop = offset.top-80;
    $('html, body').animate({scrollTop: offsetTop}, 0, 'linear');
  }

  $( window ).load(function() { // run script after content is loaded to avoid
                                // scroll to wrong position
    if ((window.location.href.indexOf("projekte-kategorien") > -1) || (window.location.href.indexOf("agentur-kategorien") > -1)){
      var element = $('#filter');
      var offset = element.offset();
      var offsetTop = offset.top-80;
      $('html, body').animate({scrollTop: offsetTop}, 0, 'linear');
    }
  });

/* 2. Off canvas menu
------------------------------------------------------------------------------*/

  var wp_admin_bar_enabled = false;

  if($('#wpadminbar').length > 0) {
    wp_admin_bar_enabled = true;
  }

  if(wp_admin_bar_enabled) {
    $('.o-site-header--fixed').css('top', $('#wpadminbar').outerHeight() + 'px');
  }

  var mainHeader = $('.o-site-header--fixed'),
      headerHeight = mainHeader.height();

  //set scrolling variables
  var scrolling = false,
    previousTop = 0,
    currentTop = 0,
    scrollDelta = 10,
    scrollOffset = 150;

  $(window).on('scroll', function(){
    if( !scrolling ) {
      scrolling = true;
      (!window.requestAnimationFrame) ? setTimeout(autoHideHeader, 250) : requestAnimationFrame(autoHideHeader);
    }
  });

  $(window).on('resize', function(){
    headerHeight = mainHeader.height();
  });

  function autoHideHeader() {
    var currentTop = $(window).scrollTop();
    checkSimpleNavigation(currentTop);
    previousTop = currentTop;
    scrolling = false;
  }

  function checkSimpleNavigation(currentTop) {
      if (previousTop - currentTop > scrollDelta) {
        //if scrolling up...
        mainHeader.removeClass('o-site-header--hidden o-site-header--fade-out');
      } else if( currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
        //if scrolling down...
        mainHeader.addClass('o-site-header--hidden');
      }
      if(currentTop <= 0 || (wp_admin_bar_enabled && currentTop == $('#wpadminbar').outerHeight())) {
        mainHeader.addClass('o-site-header--hidden o-site-header--fade-out');
      }
  }

  $('.toggle-nav, .o-menu__close').click(function() {
    // Calling a function in case you want to expand upon this.
    toggleNav();
  });

  $('.c-mobile-filter__trigger').click(function() {
    // Calling a function in case you want to expand upon this.
    toggleFilter();
  });

  $('.c-mobile-filter-alt__list').hide();
  $('.c-mobile-filter-alt__trigger').click(function() {
    // Calling a function in case you want to expand upon this.
    $(this).parent().next().slideToggle();
  });

  function toggleNav() {
    if ($('#site-wrapper').hasClass('show-nav')) {
      // Do things on Nav Close
      $('#site-wrapper').removeClass('show-nav');
    } else {
      // Do things on Nav Open
      $('#site-wrapper').addClass('show-nav');
    }
  }

  function toggleFilter() {
    if ($('body').hasClass('show-filter')) {
      // Do things on Nav Close
      $('body').removeClass('show-filter');
    } else {
      // Do things on Nav Open
      $('body').addClass('show-filter');
    }
  }

  // Fuction for hiding mobile navigation
  function hideNav() {
    if ($('#site-wrapper').hasClass('show-nav')) {
      $('#site-wrapper').removeClass('show-nav');
    }
  }

  // Hide navigation when user pressed Escape key on keyboard
  $(document).on('keyup', function(e){
    if (e.keyCode === 27) {
      if ($('#site-wrapper').hasClass('show-nav')) {
        toggleNav();
      }
    }
  });

  // Hide mobile navigation when user increases browser size
  var sizeMenuVisible = window.matchMedia("(min-width: 768px)");

  sizeMenuVisible.addListener(function(mq){
    if(mq.matches) {
      hideNav();
    }
  });

  $('ul.mob-menu li').has('ul').addClass('parentLi');
  $('ul.mob-menu li ul').addClass('sub-menu');

  $('ul.mob-menu .sub-menu').hide();

  $('ul.mob-menu .parentLi > a').on('click', function(event){
    event.preventDefault();
    $(this).toggleClass('expanded');
    $(this).parent().find('ul.sub-menu').slideToggle();
  });

/* 3. EU Cookie
------------------------------------------------------------------------------*/
/*
  // Variables
  var expires_date = new Date('December 31, 2099 23:59:59');
  var cookie_notice_height = $('.cookie-bar').height();

  // Update variables and padding after screen resize
  $(window).on("debouncedresize", function( event ) {
    cookie_notice_height = $('.cookie-bar').height();
    if(!(Cookies.get('eu-cookie-law-redact') == 'accepted' || Cookies.get('eu-cookie-law-redact') == 'refused')) {
      $('.site-footer .wrap').css('padding-bottom', cookie_notice_height + 'px');
    }
  });

  // Show cookie notice if it's not configured
  if(Cookies.get('eu-cookie-law-redact') == 'accepted' || Cookies.get('eu-cookie-law-redact') == 'refused') {
    $('body').removeClass('cookie-bar--not-decided');
  }
  else {
    $('.site-footer .wrap').css('padding-bottom', cookie_notice_height + 'px');
    $('body').addClass('cookie-bar--not-decided');
  }

  // Hide cookie if it's accepted
  $('.js-accept-cookie').on('click', function(e){
    e.preventDefault();
    Cookies.set('eu-cookie-law-redact', 'accepted', { expires: expires_date });
    $('body').removeClass('cookie-bar--not-decided');
  });

  // Disable scripts and hide notice
  $('.js-refuse-cookie').on('click', function(e){
    e.preventDefault();
    if(theme_settings.cookie_popup == 1) {
      $.magnificPopup.open({
        items: {
            src: '<div class="white-popup">' + theme_settings.cookie_popup_text + '</div>',
            type: 'inline'
        },
        mainClass: 'mfp-with-fade',
        removalDelay: 160
      });
    }
    else {
      console.log('Tracking scripts and cookies are disabled.');
    }
    Cookies.set('eu-cookie-law-redact', 'refused', { expires: expires_date });
    // Opt out functions
    // doOptout();
    $('body').removeClass('cookie-bar--not-decided');
  });
*/
/* 4. Dropdown Menu
------------------------------------------------------------------------------*/

  $('.primary-menu .menu-item-has-children > a').on('click', function(e){
    e.preventDefault();
    $(this).parent().toggleClass('opened');
  });

  // Hide dropdown after click outside the menu
  $(document).on('click', function(event) {
    if (!$(event.target).closest('.primary-menu .menu-item-has-children a').length) {
      $('.primary-menu .menu-item-has-children').removeClass('opened');
    }
  });

/* 5. Lightbox for images and videos
------------------------------------------------------------------------------*/

  $('a[href$=jpg]:not(.no-magnific), a[href$=jpeg]:not(.no-magnific), a[href$=jpe]:not(.no-magnific), a[href$=png]:not(.no-magnific), a[href$=gif]:not(.no-magnific)').magnificPopup({
    type: 'image',
    removalDelay: 500,
    mainClass: 'mfp-with-fade',
    closeOnContentClick: true,
    midClick: true
  });

  $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-with-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    iframe: {
			patterns: {
        youtube: {
          index: 'youtube.com/',
          id: function(url) {
                  var m = url.match(/[\\?\\&]v=([^\\?\\&]+)/);
                  if ( !m || !m[1] ) return null;
                  return m[1];
              },
          src: '//www.youtube.com/embed/%id%?autoplay=1'
        },
				youtube_short: {
				  index: 'youtu.be/',
				  id: 'youtu.be/',
				  src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
				}
			}
		}
  });

/* 6. Responsive Videos
/*******************************************************************************/

  /*fitvids({
    // players: 'iframe[src*="example.com"]'
  });*/

/* 7. Scoll Animations Init
/*******************************************************************************/

  AOS.init({
    disable: 'mobile',
    once: true
  });

  window.addEventListener('load', AOS.refresh);

  function refreshAOS() {
    AOS.refresh();
  }

  $('img').on('load', _.throttle(refreshAOS, 1000));

/* 8. Object Fit Images
/*******************************************************************************/

  objectFitImages();

/* 9. Framework Scripts
/*******************************************************************************/

//= include framework-scripts.js

/* 10. Contact Form 7 Fix
/*******************************************************************************/

  $('.wpcf7-form p:empty').remove();

/* 11. Accordion
/*******************************************************************************/

  // Hide all accordions
  var allPanels = $('.accordion dd').hide();
  var allTitles = $('.accordion dt');

  $('.accordion dt > a').click(function(e) {
  e.preventDefault();
  $this = $(this);
  $title = $this.parent();
  $target =  $this.parent().next();

  if(!$target.hasClass('accordion__text--active')){
    allPanels.removeClass('accordion__text--active').slideUp();
    allTitles.removeClass('accordion__subtitle--active');
    $target.addClass('accordion__text--active').slideDown();
    $title.addClass('accordion__subtitle--active');
  }
  else {
    allPanels.removeClass('accordion__text--active').slideUp();
    allTitles.removeClass('accordion__subtitle--active');
  }
  return false;
  });

/* 12. Map
/*******************************************************************************/

  $.each($('.dyn-map'), function(){

    var lat = $(this).data('lat');
    var long = $(this).data('long');
    var zoom = $(this).data('zoom');

    L.Icon.Default.imagePath = theme_settings.template_dir + '/assets/img/leaflet/';
    var mymap = new L.map($(this)[0], {
    scrollWheelZoom: false
    }).setView([lat, long], 16);

    // create custom icon
    var pinIcon = L.icon({
        iconUrl: theme_settings.template_dir + '/assets/img/leaflet/pin.svg',
        shadowUrl:  theme_settings.template_dir + '/assets/img/leaflet/marker-shadow.png',
        iconSize: [40, 50], // size of the icon
        iconAnchor:   [16, 50],
        shadowAnchor: [10, 39],
        popupAnchor:  [5, -48]
    });

    // Open Street Map - Wikimedia
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '<a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a>',
        maxZoom: zoom,
        headers: {"user-agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/86.0.4240.198 Safari/537.36"},
    }).addTo(mymap);

    if($(this).data('popup')) {
      L.marker([lat, long], {icon: pinIcon}).addTo(mymap)
      .bindPopup($(this).data('popup'))
      .openPopup();
    }

    // Open Street Map
    /*
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: zoom
    }).addTo(mymap);
    */

    // Open Street Map - Black and White
    /*
    L.tileLayer('http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: zoom
    }).addTo(mymap);
    */

    // Mapbox - remember to change accessToken
    /*
    L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
        attribution: 'Map data © <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: zoom,
        id: 'mapbox.streets',
        accessToken: 'pk.eyJ1IjoiYWRhbXBpbGNoIiwiYSI6ImNqbTY0aGlzeTB0eTEza280dGVpcjVnemMifQ.zZjr5GSWWpe4lYGBjvuz1A'
    }).addTo(mymap);
    */

    mymap.on('click', function() {
    if (mymap.scrollWheelZoom.enabled()) {
      mymap.scrollWheelZoom.disable();
      }
      else {
      mymap.scrollWheelZoom.enable();
      }
    });

  });

/* 13. Equal Heights
------------------------------------------------------------------------------*/

  // Example:
  // $('.something').matchHeight();

  // Match Height compatibility with Lazy Load techniques
  $.fn.matchHeight._maintainScroll = true;
  function refreshMatchHeight() {
    $.fn.matchHeight._update();
  }
  $('img').on('load', _.throttle(refreshMatchHeight, 1000));
  $('.team__left-side, .team__right-side').matchHeight();
  //$('.c-team-teaser__content').matchHeight();
  $('.c-teaser-minimal--mini .c-teaser-minimal__content').matchHeight();
  $('.c-teaser-alt__box-text').matchHeight();
  $('.c-teaser-alt__title').matchHeight();
  $('.c-categories').matchHeight();
  $('.c-team-teaser__content').matchHeight();
  $('.b-image-carousel__carousel-desc').matchHeight();

  /* 14. Logo list
  ------------------------------------------------------------------------------*/

  /*$('.b-logo-list__link').matchHeight();

  $('.b-logo-list__slider-wrap').on('init', function(event, slick){
    $('.b-logo-list__link').matchHeight();
  });

  $('.b-logo-list__slider-wrap').slick({
      accessibility: false,
      mobileFirst: true,
      dots: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      // autoplay: true,
      // infinite: false,
      responsive: [
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1
        }
      }
    ]
  });
*/


/* 15. Smooth Scroll
------------------------------------------------------------------------------*/

  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000);
      }
    }
  });

/* 16. Video Play
------------------------------------------------------------------------------*/

  $('.b-top-info__video-link').click(function (e) {
    e.preventDefault();
    if($(this).prev().get(0).paused){
        $(this).prev().get(0).play();
        $(this).fadeOut();
    }else{
       $(this).prev().get(0).pause();
        $(this).fadeIn();
    }
  });

  $('.b-top-info__video').click(function () {
    if($(this).get(0).paused){
      $(this).next().fadeOut();
    }
    else{
      $(this).next().fadeIn();
    }
  });

/* 17 Slick carousel- article
------------------------------------------------------------------------------*/

  /*$('.c-art-carousel').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    //autoplay: true,
    dots: true,
    arrows: true,
    autoplaySpeed: 2000,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  }); */

/* 18. Team Carousel
------------------------------------------------------------------------------*/

  /*$('.b-team-carousel__carousel').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
    ]
  });/*

/* 19. Photo Carousel
------------------------------------------------------------------------------*/

/*  $('.b-image-carousel__carousel-dots-, .b-image-carousel__carousel-dots-visible').slick({
    dots: true,
    lazyLoad: 'ondemand',
    adaptiveHeight: true
  });

  $('.b-image-carousel__carousel-dots-hidden').slick({
    dots: false,
    arrows: true,
    lazyLoad: 'ondemand',
    adaptiveHeight: true
  });

  $('.b-image-carousel__gallery').lightGallery({
    mode: 'lg-fade',
    thumbnail: false,
    fullScreen: true,
    zoom: false,
    share: false,
    download: false,
    autoplay: false,
    autoplayControls: false,
    width: '95%',
  })
  .on('onBeforePrevSlide.lg',function(event, index, fromTouch, fromThumb) {
    var currentCarousel = $(this).closest('.b-image-carousel').find('.b-image-carousel__carousel');
    currentCarousel.slick('slickGoTo', index);
  })
  .on('onBeforeNextSlide.lg',function(event, index, fromTouch, fromThumb) {
    var currentCarousel = $(this).closest('.b-image-carousel').find('.b-image-carousel__carousel');
    currentCarousel.slick('slickGoTo', index);
  });

  $('.b-image-carousel__carousel-link').on('click', function(e){
    e.preventDefault();
    $(this).closest('.b-image-carousel').find('.b-image-carousel__gallery a').eq($(this).data('photoindex')).trigger('click');
    console.log($(this).closest('.b-image-carousel').find('.b-image-carousel__gallery a').eq($(this).data('photoindex')));
  }); */

/* 20. Statistics
------------------------------------------------------------------------------*/

/*  if($(".js-animated-counter").length > 0) {
    $(".js-animated-counter").countimator({
      duration: 1600,
      //decimalDelimiter: ',',
      //thousandDelimiter: ' '
    });
  }/*

/* 21. Load more blog posts
------------------------------------------------------------------------------*/
  /* if($('.o-masonry-grid').length > 0) {
    var colc = new Colcade( '.o-masonry-grid', {
      columns: '.o-masonry-grid__col',
      items: '.o-masonry-grid__item'
    });
  }

  $('.js-load-more-blog-posts').on('click', function(e){
    e.preventDefault();
    var additionalItems = $(this).closest('.p-blog__posts-wrap').find('.p-blog__hidden-posts .o-masonry-grid__item');
    $(this).remove();
    colc.append( additionalItems )
  });

 */

}); // end of jQuery code
